import React, { useEffect, useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Checkbox,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/styles";
import moment from "moment/moment";
import EmptyData from "../../../StyledComponents/Table/EmptyData";
import TableSkeleton from "../../../StyledComponents/TableSkeleton";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },
});
function PaymentInv_Table({
  vendorList,
  loading,
  page,
  RowsPerPage,
  batchNo,
  setBatchNo,
  errorMessage,
  signatory
}) {
  const classes = useStyles();
  const [detail, setDetail] = useState([]);
  const [chequeDetail, setChequeDetail] = useState([]);
  const [data,setData]=useState(vendorList)
  useEffect(()=>{
    const signatoryData = vendorList?.filter((item) =>
      signatory?.some((signatoryValue) => item?.batchEmail.includes(signatoryValue))
    );
        if(signatoryData.length>0){
      setData(signatoryData)
    }else if(signatory[0]!==undefined && signatoryData?.length==0){
      setData([])
    }else{
    const VFData=  vendorList?.filter((item) => item?.batchEmail == "")
    setData(vendorList)
    }
  },[vendorList,signatory])

  const toggleDetail = (position) => {
    setDetail((prev) =>
      prev.includes(position) ? prev.filter((i) => i !== position) : [...prev, position]
    );
  };

  const toggleChequeDetail = (chequeNo) => {
    setChequeDetail((prev) =>
      prev.includes(chequeNo) ? prev.filter((i) => i !== chequeNo) : [...prev, chequeNo]
    );
  };

  const handleCheckboxChange = (e, num) => {
    if (e.target.checked) {
      setBatchNo((prev) => [...prev, num]);
    } else {
      setBatchNo((prev) => prev.filter((i) => i !== num));
    }
  };

  const checkAll = (e) => {
    if (e.target.checked) {
      setBatchNo(data.map((item) => item?.batchNo));
    } else {
      setBatchNo([]);
    }
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} mt={2}>
          {errorMessage && <span style={{ color: "red", marginBottom: "5px" }}>{errorMessage}</span>}
          <TableContainer className="scrollable">
            <Table className={classes.table} aria-label="a dense table" size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30", textAlign: "center" }}>
                    <Checkbox
                      disabled={data?.length === 0}
                      checked={data.length > 0 && batchNo.length === data.length}
                      onChange={checkAll}
                    />
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>Batch No</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>Batch Date</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>No of Cheque</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30", textAlign: "right" }}>Batch Amount</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30", textAlign: "center" }}>Batch Signatories</TableCell>
                </TableRow>
              </TableHead>
              {!loading && <TableBody>
                {data?.map((item) => (
                  <>
                    <TableRow>
                      <TableCell  sx={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "center",
                          }}>
                        <Checkbox
                          checked={batchNo.includes(item?.batchNo)}
                          onChange={(e) => handleCheckboxChange(e, item?.batchNo)}
                        />
                      </TableCell>
                      <TableCell onClick={() => toggleDetail(item.batchNo)}>{item?.batchNo}</TableCell>
                      <TableCell>{moment(item?.batchDate).format("YYYY-MM-DD")}</TableCell>
                      <TableCell>{item?.noOfCheque}</TableCell>
                      <TableCell textAlign="right">{Number(item?.batchAmount).toLocaleString()}</TableCell>
                      <TableCell textAlign="right">{item?.batchEmail}</TableCell>
                    </TableRow>
                    {detail.includes(item.batchNo) && (
                      <>
                        <TableRow>
                        <TableCell colSpan={6}>
                            <Table
                              style={{ margin: "20px 0px" }}
                              aria-label="a dense table"
                              size="small"
                            >
                              <TableHead>
                                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                                <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    S#
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Cheque
                                  </TableCell>                     
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Document No
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Payment Date
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >

                                    Vendor Code
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Vendor Name
                                  </TableCell>            
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Net Amount Paid
                                  </TableCell>
                                  </TableRow>
                                
                                  </TableHead>
                                  {item.batchPayment?.map((payment,index) => (
                          <>
                            <TableRow>
                            <TableCell style={{ color: "black", width: "10%" }}onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {index+1}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }}onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {payment.chequeDetail.chequeNo}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }}onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {payment.chequeDetail.documentNumber}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }}onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {payment.chequeDetail.paymentDate}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }} onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {payment.chequeDetail.vendor_Code}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }} onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {payment.chequeDetail.vendor_Name}
                              </TableCell>
                              <TableCell style={{ color: "black", width: "10%" }} onClick={() => toggleChequeDetail(payment.chequeDetail.chequeNo)}>
                                {Number(payment.chequeDetail.chequeAmount).toLocaleString()}
                              </TableCell>
                            </TableRow>
                            {chequeDetail.includes(payment.chequeDetail.chequeNo) && (
                            <TableRow>
                            <TableCell colSpan={7}>
                                <Table
                                  style={{ margin: "20px 0px" }}
                                  aria-label="a dense table"
                                  size="small"
                                >
                               <TableHead>
                               <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                               <TableCell  sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}>S#</TableCell>
                                  <TableCell  sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                   
                                    >Invoice No</TableCell>
                                  <TableCell  sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}>Invoice Date</TableCell>
                                  <TableCell sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}>Invoice Amount</TableCell>
                                  <TableCell  sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}>Invoice Description</TableCell>
                                     <TableCell  sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}>Barcode No</TableCell>
                                </TableRow>
                                </TableHead>
                                {payment.chequeDetail.invoices?.map((inv, index) => (
                                  <TableRow key={index}>
                                    <TableCell >{index+1}</TableCell>
                                    <TableCell  onClick={() =>
                                      window.open(
                                        `/#/InvDetailPage?inv=${inv?.invoice_Id}&vendorCode=${inv.vendor_Code}`
                                      )
                                    }
                                    key={index}>{inv.invoice_No}</TableCell>
                                    <TableCell >{moment(inv.invoice_Date).format("YYYY-MM-DD")}</TableCell>
                                    <TableCell >{Number(inv.invoice_Amount).toLocaleString()}</TableCell>
                                    <TableCell >{inv?.invoice_Desc!==null?inv?.invoice_Desc:"Document Number is not available in I2P Portal"}</TableCell>
                                    <TableCell>{inv.barcode}</TableCell>
                                  </TableRow>
                                ))}
                              </Table>
                              </TableCell>
                              </TableRow>
                            )}
                          </>
                        ))}
                                  </Table>
                                  </TableCell>
                        </TableRow>
                      </>
                    )}
                  </>
                ))}
              </TableBody>}
              {loading && <TableSkeleton noOfColumns={6} noOfLines={3} />}
            </Table>
            {data?.length === 0 && !loading && <EmptyData />}
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
}

export default PaymentInv_Table;
